<template>
    <div>
        <div class="news-menu">
            <div class="title">Fashion Frontier News</div>
            <div class="menu-box">
                <div class="menu-item" v-for="(item, index) in category_list" :key="index" @click="choose_category(item.id)"
                    :class="item.id === selected_category_id ? 'active' : ''">{{ item.title }}<Icon v-if="item.id === selected_category_id && sub_category_list.length>0" type="md-arrow-dropdown" :color="item.id === selected_category_id ? '#fa3d5a' : '#ffffff'" /></div>
            </div>
        </div>
        <div class="sub-menu">
            <div class="sub-menu-container">
                <div class="menu-box">
                    <div v-for="(item,index) in sub_category_list" :key="index" @click="choose_sub_category(item.id)" :class="['menu-item',{active:item.id === selected_sub_category_id}]">{{ item.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { InfoCategory } from '@/api/social'
export default{
    props:{
        id:{
            type:Number | String,
            default:0
        }
    },
    data(){
        return{
            selected_category_id: 0,
            selected_sub_category_id: 0,
            category_list: [],
        }
    },
    computed:{
        sub_category_list() {
            const arr = [];
            arr.push({id:0,title:'ALL'})
            let cate = this.category_list.find(v=>v.id===this.selected_category_id)
            if (!cate || !cate.children || !cate.children.length) {
                return arr;
            }
            arr.push(...cate.children);
            return arr ? arr : []
        },
        sel_category(){
            return this.$_.cloneDeep(this.category_list.find(item => item.id === this.selected_category_id)) || {};
        }
    },
    watch:{
        selected_category_id(newVal, oldVal){
            this.selected_sub_category_id = 0;
            this.$emit('change-cate',{selected_category_id:newVal,selected_sub_category_id:'0'});
        },
        selected_sub_category_id(newVal, oldVal) {
            if(newVal > 0) {
                this.$emit('change-sub-cate',{selected_category_id:this.selected_category_id,selected_sub_category_id:newVal});  
            }else{
                this.$emit('change-sub-cate',{selected_category_id:this.selected_category_id,selected_sub_category_id:0});
            }
        },
    },
    mounted(){
        this.getCategoryList().then(() => {
            // return this.getInfiniteList(true);
        }).finally(() => {
            if(this.$route.params.pid) {
                this.selected_category_id = this.$route.params.pid
                this.$emit('change-cate',{selected_category_id:this.$route.params.pid,selected_sub_category_id:this.$route.params.cid || '0'})
            }
            if(this.$route.params.cid) {
                setTimeout(() => {
                    this.selected_sub_category_id = this.$route.params.cid
                    this.$emit('change-sub-cate',{selected_category_id:this.$route.params.pid,selected_sub_category_id:this.$route.params.cid || '0'})
                }, 200)
            }
        })
    },
    methods:{
        async getCategoryList() {
            return InfoCategory().then(response => {
                this.category_list = response.data
                if(this.category_list.length > 0) {
                    this.selected_category_id = this.category_list[0].id
                }
            })
        },
        choose_category(id) {
            if(this.selected_category_id === id) {
                this.selected_sub_category_id = 0
                this.$emit('reload-list',true);
                // this.getInfiniteList(true);
            }
            this.selected_category_id = id
        },
        choose_sub_category(id) {
            this.selected_sub_category_id = id
            this.$emit('change-sub-cate',{selected_category_id:this.selected_category_id,selected_sub_category_id:id});  
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./info-header.scss";
</style>